import { QueryClient } from '@tanstack/react-query';
import { AnyAction, Dispatch } from 'redux';

import { effects as frontendConfigurationEffects } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import {
  apiFrontendConfigurationRetrieve,
  getApiFrontendConfigurationRetrieveQueryKey,
} from '@rover/rsdk/src/apiClient/latest';

import { PrefetchShim } from './PrefetchShim';

const prefetchFrontendConfigurationShim: PrefetchShim = async ({
  context: { isReactQueryRoute },
  apiClient,
}) => {
  if (isReactQueryRoute) {
    const queryClient = apiClient as QueryClient;
    await queryClient.prefetchQuery({
      queryKey: getApiFrontendConfigurationRetrieveQueryKey(),
      queryFn: () => apiFrontendConfigurationRetrieve(),
    });
  } else {
    const dispatch = apiClient as Dispatch<AnyAction>;
    await dispatch(frontendConfigurationEffects.fetchFrontendConfiguration());
  }
};

export default prefetchFrontendConfigurationShim;
